import React, { Component } from 'react';
// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

//Componentes Atentus
import FasView from './components/FastView'
import Fade from "@material-ui/core/Fade";
import PerfectScrollbar from "react-perfect-scrollbar";
import UserNotification from './components/UserNotification';

// Component styles
const styles = theme => ({
    root: {
        padding: theme.spacing(5),
        backgroundColor: '#e7e7e7',
        height: '100%',
    },
    item: {
        height: '100%'
    }
});

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objectivesList: {}
        }
    }
    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })
    }

    render() {
        const { classes } = this.props;
        const { objectivesList } = this.state
        return (
            <div>
                <UserNotification />

            <DashboardLayout title="Vista Rápida de Monitoreos" callbackFromParent={this.myCallback} isFirstTime={true}>
                <div className={classes.root}>

                    <Grid
                        container
                        spacing={10}
                    >
                        <Grid
                            item
                            sm={12}
                            xl={12}
                            xs={12}
                        >

                                <FasView params={objectivesList} />

                        </Grid>

                    </Grid>
                </div>
            </DashboardLayout></div>
        );
    }
}
Dashboard.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(styles)(Dashboard);